import { render, staticRenderFns } from "./CompanyUserEdit.vue?vue&type=template&id=03231bfc"
import script from "./CompanyUserEdit.vue?vue&type=script&lang=ts"
export * from "./CompanyUserEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports